// ── Per-tenant terminology (client portal) ──
// User-facing labels a tenant might want to rename (e.g. "Ledger" -> "Statement of Account",
// "Fundings" -> "Advances"). Use t("ledger") instead of hardcoding the word. Only route the
// labels you're willing to let tenants rename through here; leave the rest hardcoded.
//
// Override per tenant with a build-time env var (single-tenant-per-deployment model):
//   REACT_APP_TERMS_JSON = {"fundings":"Advances","ledger":"Statement of Account"}
// (only the keys you want to change). Or call configureTerms(obj) with an API-sourced config.

const DEFAULT_TERMS = {
  accountOverview:  "Account Overview",
  loans:            "Loans",
  ledger:           "Ledger",
  receivedPayments: "Received Payments",
  fundings:         "Fundings",
  covenants:        "Covenants",
  adjustments:      "Adjustments",
  principalPaydown: "Principal Paydown",
  loanBalance:      "Loan Balance",
};

let TERMS = { ...DEFAULT_TERMS };

// Merge tenant overrides over the defaults. Safe with null/partial.
export function configureTerms(overrides) {
  TERMS = { ...DEFAULT_TERMS, ...(overrides || {}) };
}

// Read the build-time terms config (per-tenant bundle). Returns null if unset/invalid.
export function loadTermsFromEnv() {
  try { return JSON.parse(process.env.REACT_APP_TERMS_JSON || "null"); }
  catch (e) { return null; }
}

// Look up a term. Falls back to the provided default, then the key itself.
export function t(key, fallback) {
  return (key in TERMS) ? TERMS[key] : (fallback !== undefined ? fallback : key);
}
